export class MoleculePanelEditRowTableBackupsManualComponent {
    public templateUrl = require('./backups-manual.html?external');
}
